
import { DossierConfigService } from "@/services/dossier-config-service";
import { SaleLayoutCol } from "@/utils/sale-layouts/col";
import Vue from "vue";
import AppDetailSettingsEdit from "./DetailSettingsEdit.vue";
import AppConditionsEditModal from "@/components/layout-editor/ConditionsEditModal.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleRowConditionPropSelectGroup } from "@/utils/prop-select/sale-row-to-condition-prop-group";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";

export default Vue.extend({
	data() {
		return {
			toEditCol: null as null | SaleLayoutCol,
			selectedLanguage: DossierConfigService.getLanguages().LanguageNames[0],
			rowConditionsModalOpen: false
		};
	},
	props: {
		settings: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		fullControl: Boolean
	},
	computed: {
		title(): string {
			return this.$ct("sale-detail").toString();
		},
		cols():SaleLayoutCol[]{
			return this.settings.Cols;
		},
		rowConditionsPropSelectGroup():PropSelectGroup{
			return getSaleRowConditionPropSelectGroup(false);
		}
	},
	methods: {
		edit(col: SaleLayoutCol) {
			this.toEditCol = col;
		},
		addColumn() {
			this.toEditCol = new SaleLayoutCol();
			this.cols.push(this.toEditCol);
		},
		async removeColumn(i: number) {
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("are-you-sure-you-want-to-remove-this-column")).setClass("warning").show();
			if (!confirm) {
				return;
			}
			//Is column before description
			let descriptionIndex = 0;
			this.cols.forEach((value: SaleLayoutCol, index: number) => {
				if (value.Prop == "Description") {
					descriptionIndex = index;
				}
			});
			if(i < descriptionIndex){
				console.log(this.cols[descriptionIndex].Prop);
				this.cols[descriptionIndex].Position = this.cols[i].Position;
				this.cols[descriptionIndex].Width += this.cols[i].Width;
				if(this.cols[descriptionIndex-1] && this.cols[descriptionIndex-1].Prop == "Description"){
					this.cols[descriptionIndex-1].Position = this.cols[i].Position;
					this.cols[descriptionIndex-1].Width += this.cols[i].Width;
				}
				this.cols.splice(i, 1);
			}else{
				this.cols.forEach((value: SaleLayoutCol, index: number) => {
					if(index>descriptionIndex && index < i){
						this.cols[index].Position += this.cols[i].Width;
					}
				});
				this.cols[descriptionIndex].Width += this.cols[i].Width;
				this.cols.splice(i, 1);
			}
		},
	},
	components: {
		AppDetailSettingsEdit,
		AppConditionsEditModal
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
